export interface IPublicApiScope {
	value: string;
	label: string;
	description?: string;
	comingSoon?: boolean;
}

/** Functional-domain scopes a personal API key can be granted. Mirrors the API's PublicApiScope. */
export const PUBLIC_API_SCOPES: ReadonlyArray<IPublicApiScope> = [
	{
		value: 'levitate:contacts',
		label: 'Contacts',
		description: 'Allows management of contacts, tags, key facts, companies, and notes.',
	},
	{ value: 'levitate:campaigns', label: 'Campaigns', comingSoon: true },
];
